import { render, staticRenderFns } from "./Ticket.vue?vue&type=template&id=1ccd1b3f&scoped=true"
import script from "./Ticket.vue?vue&type=script&lang=js"
export * from "./Ticket.vue?vue&type=script&lang=js"
import style0 from "./Ticket.vue?vue&type=style&index=0&id=1ccd1b3f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ccd1b3f",
  null
  
)

export default component.exports